// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"225892b9","968":"3a511687"}[chunkId] + ".chunk.js";
};